import { AppsService, SnackBarService } from 'app/services';
import { Component } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { SnackbarType } from 'app/constants/Enums';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-add-role-dialog',
  templateUrl: './add-role-dialog.component.html',
  styleUrls: ['./add-role-dialog.component.scss']
})
export class AddRoleDialogComponent {
  public inputValue: string;
  customRoles: any[] = [];
  constructor(
    private readonly appsServ: AppsService,
    private readonly _translateService: TranslateService,
    private readonly _snackbarService: SnackBarService,
    public dialogRef: MatDialogRef<AddRoleDialogComponent>
  ) {}
  private readonly onDestroy$ = new Subject<void>();

  input(_event) {
    if (this.inputValue) {
      if (this.customRoles) {
        if (
          this.customRoles.filter(e => e.name === this.inputValue).length <= 0
        ) {
          this.customRoles.push({ name: this.inputValue });
        }
      } else {
        this.customRoles = [];
        this.customRoles.push({ name: this.inputValue });
      }
      this.inputValue = '';
    }
  }


  close() {
    this.dialogRef.close();
  }
  saveData() {
    let selectedRoles = [];
    if (this.customRoles) {
      selectedRoles = JSON.parse(JSON.stringify(this.customRoles));
    }
    this.appsServ.loading=true;
    const isInternal = this.appsServ.selectedApp.clientMetadata
      ? this.appsServ.selectedApp.clientMetadata.internalOnly : false;
    const id = this.appsServ.selectedApp.clientId;
    const payload = {
      roleViewModelList: selectedRoles,
      internalOnly: isInternal
    };

    this.postRoles(payload, id);
  }
  getValue(event) {
    this.inputValue = event;
  }

  postRoles(payload, id) {
    this.appsServ.postRoles(payload, id).subscribe({
      next:(_data) => {
        this.appsServ.loading=true;
        let successMsg = '';
        let successTxt ='';
        this.customRoles = [];
        this.appsServ.getRoles(id);
        this.close();
        this._translateService
          .get('roles_added_sucessfully')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(value => (successMsg = value));
        this._translateService
          .get('SNACKBAR.success')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(value => (successTxt = value));
          this.appsServ.loading=false;
        this._snackbarService.showSnackbar(
          SnackbarType.success,
          successTxt,
          successMsg
        );
      },
      error: () => this._handleError()
    });
  }

  private _handleError() {
    this.appsServ.loading=false;
    let errorTitle ='';
    let genericErrorMsg = "";
    this._translateService
    .get('ERROR_TRY_LATER')
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((value) => (genericErrorMsg = value));
    this._translateService
      .get('SNACKBAR.error')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (errorTitle = value));
    this.appsServ.loading=false;
    this._snackbarService.showSnackbar(SnackbarType.error, errorTitle, genericErrorMsg);
  }
  
  removeRole(role) {
    this.customRoles = this.customRoles.filter(e => e.name !== role.name);
}
}
